import { render } from "./PWAInstallPrompt.vue?vue&type=template&id=13271f44"
import script from "./PWAInstallPrompt.vue?vue&type=script&lang=js"
export * from "./PWAInstallPrompt.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__